import type { EdgeId } from '@ipfabric/utils';
import {
  deviceViewPacketDetailsEntityId,
  isPacketDetailsEntity,
} from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';
import { closeDeviceViewEntity } from './closeDeviceViewEntity';

interface ClosePathLookupEdgeDetailCommand {
  detailId: EdgeId;
}

export const closePathLookupEdgeDetail: DeviceViewCommandFactory<
  ClosePathLookupEdgeDetailCommand
> = (cmdContext, dispatch) => (command) => {
  cmdContext.updateState((draft) => {
    const foundEntity = draft.deviceViewEntities.find(
      (entity) => entity.id === deviceViewPacketDetailsEntityId,
    );
    if (foundEntity !== undefined && isPacketDetailsEntity(foundEntity)) {
      foundEntity.details = foundEntity.details.filter(
        (detail) => detail.id !== command.detailId,
      );
    }
  });

  const foundEntity = cmdContext
    .getState()
    .deviceViewEntities.find(
      (entity) => entity.id === deviceViewPacketDetailsEntityId,
    );
  if (
    foundEntity !== undefined &&
    isPacketDetailsEntity(foundEntity) &&
    !foundEntity.details.length
  ) {
    dispatch(closeDeviceViewEntity, {
      deviceViewElement: 'packetDetails',
      deviceViewEntityId: foundEntity.id,
    });
  }
};
